import { forwardRef } from "react";
import { FormControl } from "../FormControl";
import type { InputProps } from "../Input";
import { useFormControlProps } from "../hooks";
import { BasePhoneInput, type BasePhoneInputProps } from "./BasePhoneInput";

export type PhoneInputProps = Omit<InputProps, "value" | "onChange" | "ref"> & BasePhoneInputProps;

export const PhoneInputInner = (
	{ defaultCountry, ...props }: PhoneInputProps,
	ref: React.ForwardedRef<HTMLInputElement>,
) => {
	const { formControlProps, errorAria, baseProps: inputProps } = useFormControlProps(props);

	return (
		<FormControl {...formControlProps}>
			<BasePhoneInput
				defaultCountry={defaultCountry}
				{...inputProps}
				{...errorAria}
				ref={ref}
				onClear={props.onClear}
			/>
		</FormControl>
	);
};

PhoneInputInner.displayName = "Input";

export const PhoneInput = forwardRef(PhoneInputInner);
